export default "__VITE_ASSET__CAt3mm9O__"